import {
  Dialog,
  IDialogProps,
  SubmissionForm,
  TextInputField
} from "@bps/fluent-ui";
import { HttpError } from "@bps/http-client";

export interface CreateEmailRequestFormValues {
  tenantId: string;
  to: string;
  ccs: string;
  subject: string;
  message: string;
}

interface ICommsEmailTestingSendDialogProps extends IDialogProps {
  onSubmit: (values: CreateEmailRequestFormValues) => Promise<void>;
  onDismiss: () => void;
  error: HttpError | null;
}

export const CreateEmailRequestDialog: React.FC<ICommsEmailTestingSendDialogProps> = ({
  onSubmit,
  onDismiss,
  error,
  ...props
}) => {
  const handleSubmit = async (values: CreateEmailRequestFormValues) => {
    await onSubmit(values);
  };

  return (
    <Dialog
      {...props}
      onDismiss={onDismiss}
      dialogContentProps={{
        showCloseButton: true,
        title: "Send Email"
      }}
    >
      <SubmissionForm<CreateEmailRequestFormValues>
        initialValues={{
          tenantId: "",
          to: "",
          ccs: "",
          subject: "Ops console testing message",
          message: "This email is an ops console testing message."
        }}
        submitButtonProps={{ text: "Send", alwaysEnabled: true }}
        onSubmit={handleSubmit}
        cancelButtonProps={{ onClick: onDismiss }}
      >
        {() => (
          <>
            <TextInputField name="tenantId" label="Tenant ID" />
            <TextInputField name="to" label="To" />
            <TextInputField name="ccs" label="Cc" />
            <TextInputField name="subject" label="Subject" />
            <TextInputField name="message" label="Message" multiline rows={3} />
          </>
        )}
      </SubmissionForm>
    </Dialog>
  );
};
